import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { AuditoriaPagoHeaderToolbar } from "./AuditoriaPagoHeaderToolbar";

export const AuditoriaPagoHeader: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <AuditoriaPagoHeaderToolbar />
            </div>
        </div>
    )
}